<template>
  <SimpleDialog
    v-model="dialog_modal"
    v-bind="settings"
    :max-width="settings.max_width"
    @close="$emit('close', $event)"
    @click:outside="$emit('close', $event)"
  >
    <template #title>
      <template v-if="!settings.is_html">
        {{ settings.title }}
      </template>
      <span
        v-else
        v-html="settings.title"
      />
    </template>

    <template #text>
      <template v-if="!settings.is_html">
        {{ settings.text }}
      </template>
      <span
        v-else
        v-html="settings.text"
      />
    </template>
    <template #button-text>
      {{ settings.button_text }}
    </template>
  </SimpleDialog>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { SimpleDialog } from '@/components';
import { BtnsPosition } from '@/components/dialogs/simple/types';
import { DialogPluginOptions } from '../types';

const default_settings = (): DialogPluginOptions => ({
  title: '',
  text: '',
  bts_align: BtnsPosition.START,
  center_title: false,
  center_text: false,
  max_width: '564',
  is_html: false,
  button_text: 'Завершить',
});

@Component({
  components: {
    SimpleDialog,
  },
})
export default class DialogPlugin extends Vue {
  settings = default_settings();

  dialog_modal = false;

  /**
   * вызывается из плагина
   */
  open_dialog(options: DialogPluginOptions) {
    Object.keys(options).forEach((key) => {
      this.settings[key] = options[key];
    });

    this.dialog_modal = true;
  }

  /**
   * вызывается из плагина.
   * передаем функцию из "on_close", которая вызывается при закрытии модального окна
   */
  close_dialog(callback?: () => void) {
    this.dialog_modal = false;
    this.settings = default_settings();

    if (callback) {
      callback();
    }
  }
}
</script>
